"use client";

import type { PropsWithChildren } from "react";

import cn from "../../utils/cn.util";
import { useCardContext } from "./context";
import { headerStyles } from "./styles";

export type CardHeaderProps = {
  className?: string;
} & PropsWithChildren;

export const Header = ({ children, className }: CardHeaderProps) => {
  const { variant } = useCardContext();

  return <div className={cn(headerStyles({ variant }), className)}>{children}</div>;
};
